import { render, staticRenderFns } from "./TipsIcon.vue?vue&type=template&id=9a1a193c&"
import script from "./TipsIcon.vue?vue&type=script&lang=js&"
export * from "./TipsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../customer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports